export const GENERATIONCAPACITY = 70;
export const COLORS={
    CARD_BACKGROUND:'#2B2C41',
    ROOT_BACKGROUND:"#686980",
    NAV_BACKGROUND: "#41425D",
    MENU_ITEM_INACTIVE_COLOR: "#60f3fa",
    MENU_ITEM_ACTIVE_COLOR: "#fafafa",
};
export const DRAWERWIDTH = 240;